module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newrepair-page"
  }, [_c('el-breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "separator": "/"
    }
  }, [_vm._l((_vm.Breadcrumbs), function(breadcrumb) {
    return [(breadcrumb.to) ? _c('el-breadcrumb-item', {
      key: breadcrumb.name,
      attrs: {
        "to": breadcrumb.to
      }
    }, [_vm._v(_vm._s(breadcrumb.name))]) : _c('el-breadcrumb-item', {
      key: breadcrumb.name
    }, [_vm._v(_vm._s(breadcrumb.name))])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "search-box"
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "维修类型",
      "prop": "library"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择维修类型"
    },
    model: {
      value: (_vm.ruleForm.library),
      callback: function($$v) {
        _vm.ruleForm.library = $$v
      },
      expression: "ruleForm.library"
    }
  }, _vm._l((_vm.librarys), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "disabled": item.flag,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "区域",
      "prop": "region"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择区域"
    },
    model: {
      value: (_vm.ruleForm.region),
      callback: function($$v) {
        _vm.ruleForm.region = $$v
      },
      expression: "ruleForm.region"
    }
  }, _vm._l((_vm.regions), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }))], 1), _vm._v(" "), _vm._l((_vm.services), function(s, index) {
    return _c('div', {
      staticClass: "item-box"
    }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
      attrs: {
        "width": "20%"
      }
    }, [_c('label', [_c('span', {
      staticStyle: {
        "color": "red",
        "padding-right": "5px"
      }
    }, [_vm._v(" * ")]), _vm._v("物料名称")]), _vm._v(" "), (_vm.ruleForm.library !== 'external') ? _c('el-select', {
      attrs: {
        "filterable": "",
        "remote": "",
        "placeholder": "物料名称/编码",
        "remote-method": _vm.remoteMethod
      },
      on: {
        "change": function($event) {
          _vm.pullLots(s)
        }
      },
      model: {
        value: (s.ProductId),
        callback: function($$v) {
          s.ProductId = $$v
        },
        expression: "s.ProductId"
      }
    }, _vm._l((_vm.materiels), function(item) {
      return _c('el-option', {
        key: item.Id,
        attrs: {
          "label": _vm.NameCode(item),
          "value": item.Id
        }
      })
    })) : _vm._e(), _vm._v(" "), _c('el-input', {
      attrs: {
        "placeholder": "物料名称/编码"
      },
      model: {
        value: (s.ProductName),
        callback: function($$v) {
          s.ProductName = $$v
        },
        expression: "s.ProductName"
      }
    })], 1), _vm._v(" "), (_vm.ruleForm.library !== 'external') ? _c('td', {
      attrs: {
        "width": "18%"
      }
    }, [_c('label', [_vm._v("批次号")]), _vm._v(" "), _c('el-select', {
      attrs: {
        "filterable": "",
        "remote": "",
        "remote-method": _vm.remoteLot,
        "placeholder": "批次号"
      },
      model: {
        value: (s.LotId),
        callback: function($$v) {
          s.LotId = $$v
        },
        expression: "s.LotId"
      }
    }, _vm._l((_vm.Lots), function(item) {
      return _c('el-option', {
        key: item.Id,
        attrs: {
          "label": item.Code,
          "value": item.Id
        }
      })
    }))], 1) : _c('td', {
      attrs: {
        "width": "18%"
      }
    }, [_c('label', [_vm._v("批次号")]), _vm._v(" "), _c('el-input', {
      attrs: {
        "placeholder": "可不填"
      },
      model: {
        value: (s.LotCode),
        callback: function($$v) {
          s.LotCode = $$v
        },
        expression: "s.LotCode"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "width": "16%"
      }
    }, [_c('label', [_c('span', {
      staticStyle: {
        "color": "red",
        "padding-right": "5px"
      }
    }, [_vm._v(" * ")]), _vm._v("品项")]), _vm._v(" "), _c('el-select', {
      attrs: {
        "filterable": "",
        "placeholder": "品项"
      },
      model: {
        value: (s.ConditionId),
        callback: function($$v) {
          s.ConditionId = $$v
        },
        expression: "s.ConditionId"
      }
    }, _vm._l((_vm.ProductCondition), function(item) {
      return _c('el-option', {
        key: item.Id,
        attrs: {
          "label": item.Name,
          "value": item.Id
        }
      })
    }))], 1), _vm._v(" "), _c('td', {
      attrs: {
        "width": "5%"
      }
    }, [_c('label', [_vm._v("数量")]), _vm._v(" "), _c('label', {
      staticClass: "quantityLabel"
    }, [_vm._v(_vm._s(s.Quantity))])]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "40%"
      }
    }, [_c('label', [_vm._v("维修原因")]), _vm._v(" "), _c('el-input', {
      attrs: {
        "placeholder": "维修原因"
      },
      model: {
        value: (s.Description),
        callback: function($$v) {
          s.Description = $$v
        },
        expression: "s.Description"
      }
    })], 1)]), _vm._v(" "), (_vm.ruleForm.library === 'external') ? _c('tr', [_c('td', [_c('label', [_vm._v("品牌")]), _vm._v(" "), _c('el-input', {
      attrs: {
        "placeholder": "可不填"
      },
      model: {
        value: (s.BrandName),
        callback: function($$v) {
          s.BrandName = $$v
        },
        expression: "s.BrandName"
      }
    })], 1), _vm._v(" "), _c('td', [_c('label', [_vm._v("机型")]), _vm._v(" "), _c('el-input', {
      attrs: {
        "placeholder": "可不填"
      },
      model: {
        value: (s.ModelName),
        callback: function($$v) {
          s.ModelName = $$v
        },
        expression: "s.ModelName"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding-right": "20px"
      }
    }, [_c('label', [_vm._v("模块")]), _vm._v(" "), _c('el-input', {
      attrs: {
        "placeholder": "可不填"
      },
      model: {
        value: (s.ModuleName),
        callback: function($$v) {
          s.ModuleName = $$v
        },
        expression: "s.ModuleName"
      }
    })], 1)]) : _vm._e()])]), _vm._v(" "), _c('el-button', {
      staticClass: "delete-btn",
      nativeOn: {
        "click": function($event) {
          _vm.deleteItem(index)
        }
      }
    }, [_vm._v("X")])], 1)
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "btn-box"
  }, [_c('el-button', {
    staticClass: "inquire pull-left",
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.addBatch($event)
      }
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('el-button', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.submit($event)
      }
    }
  }, [_vm._v("提交并等待客服联系")]), _vm._v(" "), _c('el-button', {
    staticClass: "pull-right",
    nativeOn: {
      "click": function($event) {
        _vm.cancel($event)
      }
    }
  }, [_vm._v("取消")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62a7248d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Repair/NewRepairPage.vue
// module id = 743
// module chunks = 0